module.exports = __webpack_public_path__ + "static/media/MD.d09118be.svg";